import { useContext } from "react";
import AuthenticationContext from "config/context/authenticationContext";

const RequireAuth = ({ children, permission, hasTempKey, fallback }) => {
    const { isPermissionValid } = useContext(AuthenticationContext);

    if (isPermissionValid(permission) || hasTempKey) {
        return children;
    }
    else {
        return fallback || null;
    }
}

export default RequireAuth;